import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

const steps = ["Mining or Bot trading", "Verify wallet", "Withdraw funds"];

export default function VerificationStepper() {
	return (
		<Box sx={{ width: "100%", my: "1rem" }}>
			<Stepper activeStep={1} alternativeLabel>
				{steps.map((label) => (
					<Step key={label}>
						<StepLabel>
							<span className="text-white">{label}</span>
						</StepLabel>
					</Step>
				))}
			</Stepper>
		</Box>
	);
}
